import { getDocumentosRepository } from '../repositories';
import { ApiError } from './types';
import api from '../api';

export class DocumentosService {
  private static get repository() {
    return getDocumentosRepository();
  }

  /**
   * Gera código de agendamento no formato base64(pedidoId_colaboradorId)
   * @param pedidoId - ID do pedido
   * @param colaboradorId - ID do colaborador
   * @returns Código codificado em base64
   */
  static gerarCodigoAgendamento(pedidoId: number, colaboradorId: number): string {
    const codigo = `${pedidoId}_${colaboradorId}`;
    return btoa(codigo);
  }

  /**
   * Baixa a Guia de Exame como Blob
   * @param pedidoId - ID do pedido
   * @param colaboradorId - ID do colaborador
   */
  static async downloadGuia(pedidoId: number, colaboradorId: number): Promise<Blob> {
    try {
      const codigo = this.gerarCodigoAgendamento(pedidoId, colaboradorId);
      const url = this.repository.getGuiaUrl(codigo);
      // Extrair o caminho relativo da URL completa se necessário, ou usar a URL direto se o axios tiver baseURL
      // Assumindo que repository retorna URL completa (http...), precisamos extrair o path se api já tem baseURL
      // Mas api.get aceita full URL se começar com http.
      // Melhor: usar api.get direto com a URL retornada.

      const response = await api.get(url, { responseType: 'blob' });
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Baixa ASO como Blob
   * @param pedidoId - ID do pedido
   * @param colaboradorId - ID do colaborador
   */
  static async downloadASO(pedidoId: number, colaboradorId: number): Promise<Blob> {
    try {
      const codigo = this.gerarCodigoAgendamento(pedidoId, colaboradorId);
      const url = this.repository.getASOUrl(codigo);
      const response = await api.get(url, { responseType: 'blob' });
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  /**
   * Baixa Ficha Médica como Blob
   * @param pedidoId - ID do pedido
   * @param colaboradorId - ID do colaborador
   */
  static async downloadFichaMedica(pedidoId: number, colaboradorId: number): Promise<Blob> {
    try {
      const codigo = this.gerarCodigoAgendamento(pedidoId, colaboradorId);
      const url = this.repository.getFichaMedicaUrl(codigo);
      const response = await api.get(url, { responseType: 'blob' });
      return response.data;
    } catch (error: any) {
      throw this.handleApiError(error);
    }
  }

  private static handleApiError(error: any): ApiError {
    if (error.response) {
      // Se for blob, o erro vem como blob também, precisaria converter para texto pra ler a mensagem
      // Mas para simplificar, vamos retornar msg genérica ou status code
      return {
        message: 'Erro ao gerar documento',
        statusCode: error.response.status,
        error: 'ApiError',
      };
    }
    return {
      message: error.message || 'Erro desconhecido ao gerar documento',
      statusCode: 0,
    };
  }
}

